"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coworkers = void 0;
const util_1 = require("@app/util");
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const Coworkers = ({ hasMaster, coworkers }) => {
    return !hasMaster && coworkers?.length ? (react_1.default.createElement("div", { className: 'ds-viewshift-row' },
        react_1.default.createElement("div", { style: { alignItems: 'start' }, className: 'ds-viewshift-col-label' }, (0, i18n_1.t)('VIEW_SHIFT_COWORKERS')),
        react_1.default.createElement("div", { className: 'ds-viewshift-col-value ds-viewshift-col-coworkers' }, util_1.sortUtil.sortEmployees(coworkers).map((cc, cci) => {
            const ee = cc.user;
            const sh = cc?.shifts?.length ? cc.shifts[0] : null;
            return (react_1.default.createElement("div", { key: 'cw_' + cci.toString(), className: 'ds-vsr-coworker' },
                react_1.default.createElement(_ui_1.Avatar, { profile: ee, size: 16 }),
                react_1.default.createElement("span", null, ee.name),
                sh && (react_1.default.createElement("span", { className: 'ds-coworker-shift-time' },
                    "(",
                    (0, moment_1.default)(sh.period.start).format('HH:mm') +
                        '-' +
                        (0, moment_1.default)(sh.period.end).format('HH:mm'),
                    ")"))));
        })))) : null;
};
exports.Coworkers = Coworkers;
